(function () {
  'use strict';

  angular.module('unit.status', ['ngResource']);
})();
